var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPatientIcon = function SvgPatientIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Style-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-622.000000, -201.000000)",
    fill: "#ffffff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors-Copy",
    transform: "translate(22.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620,197.714286 L620,199 L600,199 L600,197.714286 L620,197.714286 Z M605.492116,181 C605.990871,181 606.459793,181.200614 606.812448,181.564857 L606.812448,181.564857 L610,184.857143 L620,184.857143 L620,196.428571 L600,196.428571 L600,181 Z M611.86722,186.785714 L608.13278,186.785714 L608.13278,188.714286 L606.26556,188.714286 L606.26556,192.571429 L608.13278,192.571429 L608.13278,194.5 L611.86722,194.5 L611.86722,192.571429 L613.73444,192.571429 L613.73444,188.714286 L611.86722,188.714286 L611.86722,186.785714 Z M610.622407,188.071429 L610.622407,190 L612.489627,190 L612.489627,191.285714 L610.622407,191.285714 L610.622407,193.214286 L609.377593,193.214286 L609.377593,191.285714 L607.510373,191.285714 L607.510373,190 L609.377593,190 L609.377593,188.071429 L610.622407,188.071429 Z M620,182.285714 L620,183.571429 L610.515602,183.571429 L609.270788,182.285714 L620,182.285714 Z",
    id: "patient"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPatientIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/patient-icon.2fdcae6c.svg";
export { ForwardRef as ReactComponent };